/* import __COLOCATED_TEMPLATE__ from './prism-modal-close-x.hbs'; */
import { assert } from '@ember/debug';
import Component from '@ember/component';

/**
 * @class PrismModalCloseX
 */
export default Component.extend({
  /**
   * If a close action is passed in, clicking the X will perform the action
   *
   * No default.
   *
   * @argument onCloseAction
   * @type {Action}
   */
  onCloseAction: null,
  init(...args) {
    this._super(...args);
    assert('Must pass in onCloseAction to prism-modal-close-x', this.onCloseAction);
  }
});